import { render, staticRenderFns } from "./ClaimExamQr.vue?vue&type=template&id=37fe8074&"
import script from "./ClaimExamQr.vue?vue&type=script&lang=js&"
export * from "./ClaimExamQr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports